import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Fab, Tooltip, Zoom } from '@mui/material';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import { Box } from '@mui/material';

export default function BackToStream() {
  const history = useHistory();
  const location = useLocation();
  const { isStream } = useSelector((state) => state.stream);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Show button only if:
    // 1. There's an active stream
    // 2. User is NOT on the streaming page
    const isOnStreamingPage = location.pathname.includes('/LiveVideoStreaming');
    setShow(isStream && !isOnStreamingPage);
  }, [isStream, location.pathname]);

  const handleBackToStream = () => {
    // Navigate back to the streaming page
    history.push('/LiveVideoStreaming');
  };

  if (!show) return null;

  return (
    <Zoom in={show}>
      <Box
        sx={{
          position: 'fixed',
          bottom: { xs: 80, sm: 100 }, // Higher on mobile to avoid bottom nav
          right: { xs: 16, sm: 24 },
          zIndex: 1300, // Above most content but below modals
        }}
      >
        <Tooltip title="Back to Live Stream" placement="left">
          <Fab
            color="error"
            aria-label="back to stream"
            onClick={handleBackToStream}
            sx={{
              backgroundColor: '#ff0000',
              '&:hover': {
                backgroundColor: '#d32f2f',
              },
              animation: 'pulse 2s infinite',
              '@keyframes pulse': {
                '0%': {
                  transform: 'scale(1)',
                  boxShadow: '0 0 0 0 rgba(255, 0, 0, 0.7)',
                },
                '70%': {
                  transform: 'scale(1.05)',
                  boxShadow: '0 0 0 10px rgba(255, 0, 0, 0)',
                },
                '100%': {
                  transform: 'scale(1)',
                  boxShadow: '0 0 0 0 rgba(255, 0, 0, 0)',
                },
              },
            }}
          >
            <LiveTvIcon />
          </Fab>
        </Tooltip>
      </Box>
    </Zoom>
  );
}